import React from 'react';
import {
    Table,
    Header,
    HeaderRow,
    Body,
    Row,
    Cell,
} from '@table-library/react-table-library/table';
import { useRowSelect } from '@table-library/react-table-library/select';
import { usePagination } from '@table-library/react-table-library/pagination';
import { useSort, SortIconPositions, HeaderCellSort } from '@table-library/react-table-library/sort';
import { useTheme } from '@table-library/react-table-library/theme';
import { getTheme } from '@table-library/react-table-library/baseline';
import { ReactComponent as ArrowDown } from '../assets/img/arrow-down.svg';
import { ReactComponent as ArrowUp } from '../assets/img/arrow-up.svg';
import { ReactComponent as ArrowDownUp } from '../assets/img/arrow-down-up.svg';

function AreaTable(props) {
    const baseTheme = getTheme();
    const customTheme = {
        Table: `
        --data-table-library_grid-template-columns: minmax(0, auto) 120px 120px minmax(0, auto) 110px 90px;
        border-collapse: collapse;
      `,
        HeaderRow: `
        font-family: "Roboto Condensed" !important;
        font-weight: 300;
        font-size: 26px;
        border-bottom: 2px solid #555A5F;
      `,
        HeaderCell: `
        padding: 8px;
        text-align: left;
      `,
        Row: `
        color: #555A5F;
        border-bottom: 1px solid #C9CCCF;
        
        &:hover {
          background-color: #D8D8D8 !important;
        }
        
        &.unreleased {
          background: #da580694;
        }
      `,
        Cell: `
        padding: 8px;
        text-align: left;
      `,
        BaseCell: `
          div {
            white-space: normal;
          }
        `,
    };
    const theme = useTheme([baseTheme, customTheme]);

    const tblSelect = useRowSelect(props.data, {
        onChange: onSelectChange,
    });

    const pagination = usePagination(props.data, {
        state: {
            page: 0,
            size: 10,
        },
    });

    const sort = useSort(
        props.data,
        {
            state: {
                sortKey: 'CREATIONDATE',
                reverse: true,
            },
            onChange: (action, state) => { },
        }, 
        {
            sortIcon: {
                iconDefault: <ArrowDownUp />,
                iconUp: <ArrowUp />,
                iconDown: <ArrowDown />,
                position: SortIconPositions.Prefix,
            },
            sortFns: {
                NAME: (array) => array.sort((a, b) => a.name.localeCompare(b.name)),
                CREATIONDATE: (array) => array.sort((a, b) => a.creationTimeUnixMs - b.creationTimeUnixMs),
                EXPIRATIONDATE: (array) => array.sort((a, b) => a.expirationDateUnixMs - b.expirationDateUnixMs),
                DESCRIPTION: (array) => array.sort((a, b) => a.description - b.description),
                AREASPACE: (array) => array.sort((a, b) => a.areaSpace - b.areaSpace),
                USEDSPACE: (array) => array.sort((a, b) => a.usedSpace - b.usedSpace),
            },
        },
    );

    function onSelectChange(action, state) {
        props.clickedIdChange(state.id);
    }

    const dateOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    };

    return (
        <>
            <Table data={props.data} theme={theme} layout={{ custom: true }}
                select={tblSelect} pagination={pagination} sort={sort}>
                {(tableList) => (
                    <>
                        <Header>
                            <HeaderRow>
                                <HeaderCellSort sortKey="NAME" resize>Name</HeaderCellSort>
                                <HeaderCellSort sortKey="CREATIONDATE" resize>Creation</HeaderCellSort>
                                <HeaderCellSort sortKey="EXPIRATIONDATE" resize>Expiration</HeaderCellSort>
                                <HeaderCellSort sortKey="DESCRIPTION" resize>Description</HeaderCellSort>  
                                <HeaderCellSort sortKey="AREASPACE" resize>Max size</HeaderCellSort>
                                <HeaderCellSort sortKey="USEDSPACE" resize>Used</HeaderCellSort>
                            </HeaderRow>
                        </Header>

                        <Body>
                            {tableList.map((item) => (
                                <Row key={item.id} item={item} className={item.status === 0 ? "unreleased" : "released"}>
                                    <Cell>{item.name}</Cell>
                                    <Cell>{new Date(item.creationTimeUnixMs).toLocaleDateString(undefined, dateOptions)}</Cell>
                                    <Cell>
                                        {item.doesNotExpire ?
                                            'Never' :
                                            new Date(item.expirationDateUnixMs).toLocaleDateString(undefined, dateOptions)}
                                    </Cell>
                                    <Cell>{item.description}</Cell>
                                    <Cell>{item.areaSpace}</Cell>
                                    <Cell>{Math.round(item.usedSpace / 10000 + 100 * Number.EPSILON) / 100}</Cell>
                                </Row>
                            ))}
                        </Body>
                    </>
                )}
            </Table>


            <br />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Total Pages: {pagination.state.getTotalPages(props.data.nodes)}</span>

                <span>
                    Page:{' '}
                    {pagination.state.getPages(props.data.nodes).map((_, index) => (
                        <button
                            key={index}
                            className="tblPageBtn"
                            type="button"
                            style={{
                                fontWeight: pagination.state.page === index ? 'bold' : 'normal',
                            }}
                            onClick={() => pagination.fns.onSetPage(index)}
                        >
                            {index + 1}
                        </button>
                    ))}
                </span>
            </div>
        </>
    );
};

export default AreaTable;